import { render } from "./CustomerContactInfo.vue.ts?vue&type=template&id=051bdbb0&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerContactInfo.vue?vue&type=template&id=051bdbb0&scoped=true&ts=true"
import script from "./CustomerContactInfo.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerContactInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerContactInfo.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerContactInfo.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerContactInfo.vue.scss?vue&type=style&index=0&id=051bdbb0&lang=scss&scoped=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerContactInfo.vue?vue&type=style&index=0&id=051bdbb0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051bdbb0"],['__file',"src/apps/merchant3/components/customer-registration/customer-contact-info/CustomerContactInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "051bdbb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('051bdbb0', __exports__)) {
    api.reload('051bdbb0', __exports__)
  }
  
  module.hot.accept("./CustomerContactInfo.vue.ts?vue&type=template&id=051bdbb0&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerContactInfo.vue?vue&type=template&id=051bdbb0&scoped=true&ts=true", () => {
    api.rerender('051bdbb0', render)
  })

}


export default __exports__